import { firestore as db } from "src/Firebase"

const subscribeAdminsAndSupervisors = observer => {
  const snapshots = new Map()
  const unsubscribers = ["administrador", "supervisor"].map(role =>
    db
      .collection("usuarios")
      .where(`Roles.${role}`, "==", true)
      .onSnapshot({
        next: snapshot => {
          snapshots.set(role, snapshot)
          if (snapshots.size < 2) return
          const docsById = new Map()
          snapshots.forEach(result => {
            result.docs.forEach(doc => docsById.set(doc.id, doc))
          })
          observer.next({ docs: Array.from(docsById.values()) })
        },
        error: error => observer.error?.(error),
      })
  )
  return () => unsubscribers.forEach(unsubscribe => unsubscribe())
}

export default subscribeAdminsAndSupervisors
